import { useCallback } from "react";
import { useMedia } from "@medbillai/ui";
import { issuesUrl } from "@medbillai/utils";
import { Flag } from "@medbillai/utils/flag";
import type { CaseAnalyticsSource } from "../../lib/analytics";
import { analyticsService } from "../../lib/analytics";
import { useBoolVariation } from "../../lib/flag";
import { useCasesPanel } from "./CasesPanelProvider";
export type ViewAllCasesAction = {
  /** Set when "view all" navigates; absent when it opens the panel in place. */
  href?: string;
  onPress: () => void;
};

// Desktop with the new case-list panel (NEW_CASELIST_UI) opens it in place;
// mobile web has no panel, so it falls back to the full cases page.
export function useViewAllCasesAction(source: CaseAnalyticsSource): ViewAllCasesAction {
  const media = useMedia();
  const showCasesPanelV2 = useBoolVariation(Flag.NEW_CASELIST_UI, false);
  const {
    togglePanel
  } = useCasesPanel();
  const opensPanel = media.gtSm && showCasesPanelV2;
  const onPress = useCallback(() => {
    analyticsService.trackEvent("ViewAllCasesTapped", {
      source
    });
    if (opensPanel) {
      togglePanel("home_your_cases", true);
    }
  }, [source, opensPanel, togglePanel]);
  return opensPanel ? {
    onPress
  } : {
    href: issuesUrl(),
    onPress
  };
}